/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, jsx } from '@atlaskit/css';
import { Inline } from '@atlaskit/primitives/compiled';
import Spinner, { type Size } from '@atlaskit/spinner';

const styles = cssMap({
	loader: {
		height: '100%',
		width: '100%',
	},
});

interface LoadingStateProps {
	testId?: string;
	size?: Size;
}

export const LoadingState = ({ testId, size = 'xlarge' }: LoadingStateProps): JSX.Element => {
	return (
		<Inline testId={testId} alignBlock={'center'} alignInline={'center'} xcss={styles.loader}>
			<Spinner size={size} />
		</Inline>
	);
};
